export default __webpack_public_path__ + "bac488637e5f6f599bfd647bfa5a2399.png";